<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-form-group#input-group-responsable(
      label="Responsable",
      label-for="input-responsable"
    )
      b-form-select(
        v-model="form.userId"
        id="input-responsable"
        :options="getCollaborators()"
        placeholder="Selecciona un Encargado."
      )
    b-form-group#input-group-reminder(
      label="Recordatorio ",
      label-for="input-expirationDate"
    )
      .reminder
        b-form-datepicker.date#input-reminder(
          v-model="date",
          locale="es-CL",
          placeholder="Fecha del Recordatorio."
        )
        b-form-timepicker.time#input-time(
          v-if="date!==null"
          v-model="time",
          locale="es",
          placeholder="Hora"
        )
    b-form-group#input-group-description(
      label="Nota",
      label-for="input-description"
    )
      b-form-textarea(
        v-model="form.description"
        id="input-description"
        rows=4,
        no-resize
        :state="$v.$dirty ? !$v.form.description.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.description.requiredIf") Campo requerido
    .modal-footer
      b-button(@click="hideModal" variant="outline-muted") Cancelar
      b-button.boton(type="submit") {{ action === 'create' ? 'Crear' : 'Editar' }}
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { mapActions , mapGetters } from "vuex";
export default {
  props: [ "selectedNote", "action", "hideModal", "makeToast", "filterUser", "order"],
  validations: {
    form: {
      description: { required }
    }
  },
  data() {
    return {
      date: this.action === 'create' ? null : (this.selectedNote.reminder ? this.$moment(this.selectedNote.reminder).format('YYYY-MM-DD') : null),
      time: this.action === 'create' ? null : (this.selectedNote.reminder ? this.$moment(this.selectedNote.reminder).format('HH:mm') : null),
      form: {
        id: this.action === 'create' ? null : this.selectedNote.id,
        description: this.action === 'create' ? null : this.selectedNote.description,
        userId:  this.action === "create" ? null : (this.selectedNote.userId ? this.selectedNote.userId.id: null),
        reminder: this.action === 'create' ? null : (this.selectedNote.reminder ? this.selectedNote.reminder : null),
        done: this.action === 'create' ? false : this.selectedNote.done,
      },
    };
  },
  methods: {
    ...mapActions(["updateNote", "createNote"]),
    ...mapActions('UserStore',['listUsers']),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        const payload = this.form;
        if (this.form.userId === null) {
          this.form.userId = this.user.id
        }
        if ( this.date && this.time){
          this.form.reminder = (this.date + ' ' + this.time)
          this.form.reminder = this.$moment(this.form.reminder)
        }
        const action = this.action === "create" ? this.createNote : this.updateNote;
        const response = await action(payload);
        if (response.status === 200 || response.status === 201) {
          this.makeToast("success", response.data.message, "Éxito!");
          this.hideModal();
        } else {
          this.makeToast("danger", response.data, "Ocurrió un error!");
        }
      }
    },
    getCollaborators () {
      const collaboratorOptions = [{'text': 'Selecciona un Encargado.','value': null}]
      this.users.forEach(user => {
        if(user.role === 'collaborator' || user.role === 'owner'){
          collaboratorOptions.push({
            text: user.name +' '+ user.lastName,
            value: user.id
          })
        }
      })
      return collaboratorOptions
    }
  },
  computed :{
    ...mapGetters('UserStore',['users']),
    ...mapGetters('AuthenticationStore', ['user'])
  },
  created(){
    this.listUsers()
  }
};
</script>
<style scoped>
.reminder {
  display: flex;
}
.time {
  width: 160px;;
}
</style>